import { useParams } from "react-router";
import { ContractForOffer } from "@/routes/processes/[processId]/vbs/offers/[offerId]/contract/_components/contract-for-offer";
import { ErrValidationFailedContextProvider } from "@/shared/lib/errors/err-validation-failed-context";

export function OfferContractRoute() {
  const { offerId } = useParams();

  // The contract is a document of its own. Its provider shadows the one of
  // the offer, so the shared cards of the contract do not show the offer's
  // errors, and the errors of the contract stay out of the offer's scope.
  return (
    <ErrValidationFailedContextProvider>
      <ContractForOffer offerId={offerId!} />
    </ErrValidationFailedContextProvider>
  );
}
